import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Login.css'; // Assurez-vous d'avoir un fichier CSS pour le style

const Login = () => {

  const BASE_URL = process.env.REACT_APP_API_URL; // Ou utilisez une variable d'environnement
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/ilrialto/auth/login`, { email, password });
      // Stocker le token JWT
      localStorage.setItem('token', response.data.token);
      // Rediriger vers le dashboard ou une autre page
      window.location.href = '/dashboard';
    } catch (error) {
      setError('Erreur lors de la connexion');
      console.error(error);
    }
  };

  return (
    <div className='login-container'>
      <h1>Login</h1>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Mot de passe"
      />
      <button onClick={handleLogin}>Se connecter</button>
      {error && <p>{error}</p>}
    </div>
  );
};

export default Login;
